import React from "react";
import SectionHeading from "components/SectionHeading";
import classes from "../style.module.scss";
import PrivacyPolicyContent from "./Content";

export default () => (
    <div>
        <SectionHeading
            title="Privacy Policy"
            subtitle="How we collect, store, use, and disclose your personal data."
        />
        <div className={classes.contentWrapper}>
            <PrivacyPolicyContent />
        </div>
    </div>
);
